import { gql } from "graphql-request";

export const CREATE_PUBLIC_HOLIDAY = gql`
  mutation CreatePublicHoliday($input: CreatePublicHolidayInput!) {
    createPublicHoliday(input: $input) {
      id
      jurisdiction
      name
      date
      observedDate
      year
      source
    }
  }
`;

export const UPDATE_PUBLIC_HOLIDAY = gql`
  mutation UpdatePublicHoliday($input: UpdatePublicHolidayInput!) {
    updatePublicHoliday(input: $input) {
      id
      jurisdiction
      name
      date
      observedDate
      year
      source
    }
  }
`;

export const DELETE_PUBLIC_HOLIDAY = gql`
  mutation DeletePublicHoliday($id: ID!) {
    deletePublicHoliday(id: $id)
  }
`;

export const CREATE_HOLIDAY_REQUEST = gql`
  mutation CreateHolidayRequest($input: CreateHolidayRequestInput!) {
    createHolidayRequest(input: $input) {
      id
      status
    }
  }
`;

export const APPROVE_HOLIDAY_REQUEST = gql`
  mutation ApproveHolidayRequest($id: ID!, $decisionComment: String) {
    approveHolidayRequest(id: $id, decisionComment: $decisionComment) {
      id
      status
      decisionComment
      decidedAt
    }
  }
`;

export const REJECT_HOLIDAY_REQUEST = gql`
  mutation RejectHolidayRequest($id: ID!, $decisionComment: String) {
    rejectHolidayRequest(id: $id, decisionComment: $decisionComment) {
      id
      status
      decisionComment
      decidedAt
    }
  }
`;